import React from "react";

const SectionHeader = ({ icon: Icon, number, title, subtitle }) => (
  <div className="feedback-section-header">
    <div className="feedback-section-icon">
      <Icon />
    </div>
    <div className="feedback-section-text">
      <p className="feedback-question-label">Question {number}</p>
      <h3 className="feedback-question-title">{title}</h3>
      {subtitle && <p className="feedback-question-subtitle">{subtitle}</p>}
    </div>
  </div>
);

const OptionCard = ({ label, checked, onChange, type }) => (
  <div
    className={`feedback-option-card${checked ? " selected" : ""}`}
    onClick={onChange}
  >
    <input
      type={type === "radio" ? "radio" : "checkbox"}
      checked={checked}
      onChange={() => {}}
      tabIndex={-1}
    />
    <span className="option-label">{label}</span>
  </div>
);

export default function FeedbackQuestion({
  id,
  onFocus,
  onClick,
  icon,
  number,
  title,
  subtitle,
  type, // "checkbox" | "radio" | "rating" | "text"
  options,
  value,
  onChange,
  hasOther,
  otherValue,
  onOtherChange,
  gridCols = 2,
  faces = [],
}) {
  const handleToggle = (optValue) => {
    if (type === "checkbox") {
      if (value.includes(optValue)) {
        onChange(value.filter((v) => v !== optValue));
      } else {
        onChange([...value, optValue]);
      }
    } else if (type === "radio") {
      onChange(optValue);
    }
  };

  return (
    <div
      className="feedback-question"
      id={id}
      onClick={onClick}
      onFocus={onFocus}
    >
      <SectionHeader icon={icon} number={number} title={title} subtitle={subtitle} />
      
      {(type === "checkbox" || type === "radio") && (
        <>
          <div className={`feedback-options-grid ${gridCols === 3 ? "three-col" : ""}`}>
            {options?.map((opt) => (
              <OptionCard
                key={`${id}-${opt.value}`}
                type={type}
                label={opt.label}
                checked={type === "checkbox" ? value.includes(opt.value) : value === opt.value}
                onChange={() => handleToggle(opt.value)}
              />
            ))}
          </div>
          {hasOther && (
            <div className="feedback-other-row">
              <OptionCard
                type={type}
                label="Other"
                checked={type === "checkbox" ? value.includes("other") : value === "other"}
                onChange={() => handleToggle("other")}
              />
              {(type === "checkbox" ? value.includes("other") : value === "other") && (
                <input
                  type="text"
                  className="feedback-other-input"
                  placeholder="Please specify..."
                  value={otherValue}
                  onChange={(e) => onOtherChange(e.target.value)}
                />
              )}
            </div>
          )}
        </>
      )}

      {type === "rating" && (
        <div className="feedback-nps-container">
          <div className="feedback-nps-faces">
            {faces.map((face) => {
              const isSelected = value === face.value;
              const hasSel = value !== "";
              return (
                <div
                  key={face.value}
                  className={`feedback-nps-face${isSelected ? " selected" : ""}${hasSel && !isSelected ? " dimmed" : ""}`}
                  onClick={(e) => {
                    e.stopPropagation();
                    onChange(face.value);
                  }}
                >
                  <div
                    className={`feedback-nps-icon-wrapper${isSelected ? " selected" : ""}`}
                    style={{
                      backgroundColor: isSelected ? `${face.color}15` : "transparent",
                      borderColor: isSelected ? face.color : "transparent",
                    }}
                  >
                    <face.Face size={38} color={face.color} />
                  </div>
                  <span
                    className={`feedback-nps-value${isSelected ? " selected" : ""}`}
                    style={{ color: isSelected ? face.color : "#8D8D8D" }}
                  >
                    {face.value}
                  </span>
                </div>
              );
            })}
          </div>
          <div className="feedback-nps-labels">
            <span>Not likely</span>
            <span>Very likely</span>
          </div>
        </div>
      )}

      {type === "text" && (
        <textarea
          className="feedback-textarea"
          rows={4}
          placeholder="We'd love to hear your thoughts..."
          value={value}
          onChange={(e) => onChange(e.target.value)}
        />
      )}
    </div>
  );
}
